import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderPt = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Adivinha onde esta o dinheiro."
                highlights={[
                    { word: 'Adivinha' },
                    { word: 'onde' },
                    { word: 'esta' },
                    { word: 'o' },
                    { word: 'dinheiro.' },
                ]}
                breakAfterWords={isDesktop ? [] : ['onde']}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Tens tres tentativas!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
